
import { Component, VModel, Vue } from "vue-property-decorator";

@Component
export default class ImportClaimReview extends Vue {
  @VModel({ required: true }) show!: boolean;
 
}
